import React from 'react';
import { Table, Form } from 'react-bootstrap';
import "./LearnerSelectionTable.css";

const LearnerSelectionTable = ({ onSelect, columns, rows, selectedKey, getRowKey }) => {
    return ((rows.length > 0 || Object.keys(rows).length > 0) && <div className="learner-selection-table-container">
        <Table className="learner-selection-table" bordered hover responsive size="sm">
            <thead className="table-head bg-light">
                <tr className="table-row">
                    <th className="table-header empty-header"></th>
                    {columns.map((col) => (
                        <th className="table-header" key={col.key}>{col.label}</th>
                    ))}
                </tr>
            </thead>
            <tbody className="table-body">
                {rows.map((row, rowIndex) => (
                    <tr key={row.id || rowIndex} className="table-row">
                        <td className="bg-light text-center align-middle table-data">
                            <Form.Check
                                type="radio"
                                name="selectedLearner"
                                checked={
                                    typeof getRowKey === "function"
                                        ? getRowKey(row) === selectedKey
                                        : false
                                }
                                onChange={() => onSelect(row)}
                            />
                        </td>
                        {columns.map((col) => (
                            <td className="table-data" key={col.key}>{row[col.key]}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </Table>
    </div>);
};

export default LearnerSelectionTable;